<template>
  <div class="tour">
    <TournmentInfo
      :config="config"
      :loggedin="loggedin"
      :course="course"
      :title="title"
      :data="data"
      :tourinfo="tourinfo"
      :until="until"
      splash="splash"
      splashText="splashText"
      logo="logo"
      overlay="overlay"
      courseStats="courseStats"
      :id="this.$route.query.id"
      :code="this.$route.query.code"
      :isMobile="isMobile"
      :changeReport="changeReport"
      :outVal="outVal"
      :inVal="inVal"
      :totalVal="totalVal"
      :currentStatus="currentStatus"
      :onEnter="onEnter"
      :onWithdraw="onWithdraw"
      :onPay="onPay"
      :PlayerLogged="PlayerLogged"
      :reportData="reportData"
      :filterReports="filterReports"
      :DEFIMAGESAMS3="DEFIMAGESAMS3"
      :showcountDown="showcountDown"
      :FullListPrize="FullListPrize"
    />
    <div v-if="hideLoader == false">
      <div class="insideLoader">
        <div class="loader"></div>
        <h2 class="HeaderText reportInfo loadReports">Loading Reports</h2>
      </div>
    </div>
    <div v-else>
      <div class="heightColorDiv"></div>
      <div class="tourInfo reportSection container tournReportSection">
        <div v-if="title.includes('Score')">
          <div class="TitleArea">
            <span v-if="title.includes('Score')">
              <h3 class="courseDates TitleAreaScore">
                {{ data.course_dates }}
              </h3>
              <h3 class="courseDates lastRealTime-update">
                Last Real Time Update -
                {{ data.last_scores_update_date }} - {{ data.course_city }} Time -
                {{ data.last_scores_update_time }}
                {{ data.last_scores_update_date }}
              </h3>
              <template v-if="showGender == 'Y'">
                <p class="showPgender">
                  <span class="multiDot-size-reportgender male">• </span> = Men
                  Professional <br />
                  <span class="multiDot-size-reportgender female">• </span> =
                  Ladies Professional
                </p>
              </template>
            </span>
          </div>
          <b-tabs content-class="mt-3" class="tabsLi">
            <template v-if="data.hide_gross_sb == 'Y'">
              <b-tab title="LEADERBOARD" active title-item-class="nonactive">
                <template v-if="data.stableford == 'Y'">
                  <ScoreTeam
                    :data="data"
                    :title="title"
                    :home="false"
                    :config="config"
                    :team="teamEvent"
                    :match="tourinfo.match_play"
                    :code="code"
                    :season="season"
                    :showGender="showGender"
                    :is_qualifier="is_qualifier"
                    :stableford="stableford"
                    :show_info_web="show_info_web"
                    :hide_score_card="hide_score_card"
                    :useName="useName"
                  />
                </template>
                <template v-else>
                  <ReportTable
                    :data="data"
                    :title="title"
                    :home="false"
                    :config="config"
                    :team="teamEvent"
                    :match="tourinfo.match_play"
                    :code="code"
                    :season="this.$route.query.id"
                    :showGender="showGender"
                    :is_qualifier="is_qualifier"
                    :stableford="stableford"
                    :show_info_web="show_info_web"
                    :hide_score_card="hide_score_card"
                    :useName="useName"
                  />
                </template>
              </b-tab>
              <b-tab title="HOLE-BY-HOLE" title-item-class="nonactive HBH">
                <HBH
                  :data="data"
                  :previousData="previousData"
                  :config="config"
                  :title="title"
                  :showGender="showGender"
                  :show_info_web="show_info_web"
                  :hide_score_card="hide_score_card"
                  :useName="useName"
                />
              </b-tab>
            </template>
            <template v-else>
              <template v-if="data.tt_code == '2B'">
                <b-tab
                  active
                  title="LEADERBOARD"
                  title-item-class="nonactive"
                >
                  <template v-if="data.stableford == 'Y'">
                    <ScoreTeamSST
                      :data="data"
                      :title="title"
                      :home="false"
                      :config="config"
                      :team="teamEvent"
                      :match="tourinfo.match_play"
                      :code="code"
                      :season="season"
                      :showGender="showGender"
                      :is_qualifier="is_qualifier"
                      :stableford="stableford"
                      :show_info_web="show_info_web"
                      :hide_score_card="hide_score_card"
                      :useName="useName"
                    />
                  </template>
                  <template v-else>
                    <ReportTable
                      :data="data"
                      :title="title"
                      :home="false"
                      :config="config"
                      :team="teamEvent"
                      :match="tourinfo.match_play"
                      :code="code"
                      :season="this.$route.query.id"
                      :showGender="showGender"
                      :is_qualifier="is_qualifier"
                      :stableford="stableford"
                      :show_info_web="show_info_web"
                      :hide_score_card="hide_score_card"
                      :useName="useName"
                    />
                  </template>
                </b-tab>
                <b-tab title="HOLE-BY-HOLE" title-item-class="nonactive HBH">
                  <HBH
                    :data="data"
                    :previousData="previousData"
                    :config="config"
                    :title="title"
                    :showGender="showGender"
                    :show_info_web="show_info_web"
                    :hide_score_card="hide_score_card"
                    :useName="useName"
                  />
                </b-tab>
              </template>
              <template v-else>

                <b-tab title="LEADERBOARD" active title-item-class="nonactive">
                  <ReportTable
                    :data="data"
                    :title="title"
                    :home="false"
                    :config="config"
                    team="N"
                    :match="tourinfo.match_play"
                    :code="code"
                    :season="this.$route.query.id"
                    :showGender="showGender"
                    :is_qualifier="is_qualifier"
                    :stableford="stableford"
                    :show_info_web="show_info_web"
                    :hide_score_card="hide_score_card"
                    :useName="useName"
                  />
                </b-tab>
                <template v-if="data.match_play == 'N'">
                  <b-tab
                    title="TEAM"
                    v-if="teamEvent === 'Y'"
                    title-item-class="nonactive"
                  >
                    <template v-if="data.stableford == 'Y'">
                      <ScoreTeam
                        :data="data"
                        :title="title"
                        :home="false"
                        :config="config"
                        :team="teamEvent"
                        :match="tourinfo.match_play"
                        :code="code"
                        :season="season"
                        :showGender="showGender"
                        :is_qualifier="is_qualifier"
                        :stableford="stableford"
                        :show_info_web="show_info_web"
                        :hide_score_card="hide_score_card"
                        :useName="useName"
                      />
                    </template>
                    <template v-else>
                      <ReportTable
                        :data="data"
                        :title="title"
                        :home="false"
                        :config="config"
                        :team="teamEvent"
                        :match="tourinfo.match_play"
                        :code="code"
                        :season="this.$route.query.id"
                        :showGender="showGender"
                        :is_qualifier="is_qualifier"
                        :stableford="stableford"
                        :show_info_web="show_info_web"
                        :hide_score_card="hide_score_card"
                        :useName="useName"
                      />
                    </template>
                  </b-tab>
                  <b-tab title="HOLE-BY-HOLE" title-item-class="nonactive HBH">
                    <HBH
                      :data="data"
                      :previousData="previousData"
                      :config="config"
                      :title="title"
                      :showGender="showGender"
                      :show_info_web="show_info_web"
                      :hide_score_card="hide_score_card"
                      :useName="useName"
                    />
                  </b-tab>
                </template>
              </template>
            </template>
          </b-tabs>
        </div>
        <div v-else>
          <ReportTable
            :data="data"
            :title="title"
            :home="false"
            :config="config"
            :team="team"
            :match="tourinfo.match_play"
            :code="code"
            :season="this.$route.query.id"
            :showGender="showGender"
            :is_qualifier="is_qualifier"
            :stableford="stableford"
            :show_info_web="show_info_web"
            :hide_score_card="hide_score_card"
            :useName="useName"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiCall from "@/services/api.js";
import TournmentInfo from "@/components/tournamentInfo.vue";
import ReportTable from "@/components/reportTable.vue";
// import { HBH, ScoreTeam } from "@ocs-software/vue-ocs";
import { HBH, ScoreTeamSST, ScoreTeam } from "@ocs-software/vue-ocs";
import socketServe from "@/js/socketio-services.js";
export default {
  name: "Tournament",
  components: { ReportTable, HBH, TournmentInfo, ScoreTeamSST, ScoreTeam },
  props: ["config", "loggedin", "course", "apiClass", "showGender"],
  data() {
    return {
      data: [],
      tourinfo: [],
      splash: "splash",
      splashText: "splashText",
      logo: "logo",
      overlay: "overlay",
      courseStats: "courseStats",
      until: [],
      id: this.$route.query.id,
      code: this.$route.query.code,
      title: "",
      report: "",
      form: {
        text: ""
      },
      polling: null,
      reportData: {},
      filterReports: {},
      ListlastTite: '',
      lastListURL: [],
      ListlastURL: '',
      ReportTitleText: null,
      tourinfoDate: '',
      months: [
        {
          'date' : 'January',
          'short' : 'Jan',
          'num' : '01'
        },
        {
          'date' : 'Febuary',
          'short' : 'Feb',
          'num' : '02'
        },
        {
          'date' : 'March',
          'short' : 'Mar',
          'num' : '03'
        },
        {
          'date' : 'April',
          'short' : 'Apr',
          'num' : '04'
        },
        {
          'date' : 'May',
          'short' : 'May',
          'num' : '05'
        },
        {
          'date' : 'June',
          'short' : 'Jun',
          'num' : '06'
        },
        {
          'date' : 'July',
          'short' : 'Jul',
          'num' : '07'
        },
        {
          'date' : 'August',
          'short' : 'Aug',
          'num' : '08'
        },
        {
          'date' : 'September',
          'short' : 'Sep',
          'num' : '09'
        },
        {
          'date' : 'October',
          'short' : 'Oct',
          'num' : '10'
        },
        {
          'date' : 'November',
          'short' : 'Nov',
          'num' : '11'
        },
        {
          'date' : 'December',
          'short' : 'Dec',
          'num' : '12'
        },
      ],
      MonthSel: [],
      newSelectDay: '',
      setTime: null,
      clearTime: null,
      clearName: this.$route.name,
      countdownTimer: null,
      countdownTarget: null,
      selDay: null,
      selMonth: null,
      clearDate: null,
      tournCountdownTimer: null,
      showcountDown: true,
      hideLoader: false,
      FullListPrize: []
    };
  },
  metaInfo() {
    return {
      title: this.tourinfo.full_name,
      meta: [
        { charset: "utf-8" },
        { name: "description", content: this.description }
      ]
    };
  },
  methods: {
    tournCountdown(tourn) {
      // console.log('tourncountDown', tourn.code);

      let sDate = [];
      let sdDate = 0;
      let sdMnth = 0;
      let sdYear = 0;
      let sTime = [];
      let stHour = 0;
      let stMins = 0;
      let startDate = {};
      let timeDiff = 0;

      const nowDate = new Date();
      const currCent = String(nowDate.getFullYear()).substring(0, 2);

      if (tourn.start_date.length) {
        sDate = tourn.start_date.split('/');
        sdDate = parseInt(sDate[0]);
        sdMnth = parseInt(sDate[1] - 1);
        sdYear = parseInt(currCent + sDate[2]);
      }

      if (tourn.start_time.length) {
        sTime = tourn.start_time.split(':');
        stHour = parseInt(sTime[0]);
        stMins = parseInt(sTime[1]);
      }

      startDate = new Date(sdYear, sdMnth, sdDate, stHour, stMins);
      timeDiff = (startDate.getTime() - nowDate.getTime());

      const secs = 1000, mins = (secs * 60), hours = (mins * 60), days = (hours * 24);
      const diffDays = Math.floor(timeDiff / days);
      if (diffDays <= '0') {
        this.showcountDown = false
      } else {
        this.showcountDown = true  
      }
      const diffHours = Math.floor((timeDiff % days) / hours);
      const diffMins = Math.floor((timeDiff % hours) / mins);
      const diffSecs = Math.floor((timeDiff % mins) / secs);
      // console.log('days', diffDays);
      // console.log('hours', diffHours);
      // console.log('minutes', diffMins);
      // console.log('seconds', diffSecs);

      if (document.getElementById("days")) {
        document.getElementById("days").innerText = diffDays;
        document.getElementById("hours").innerText = diffHours;
        document.getElementById("minutes").innerText = diffMins;
        document.getElementById("seconds").innerText = diffSecs; 
      }

      this.tournCountdownTimer = setTimeout(() => {
        this.tournCountdown(tourn);
      }, 1000);
    },
    isMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
    changeReport: function(event) {
      var report = event.target.getAttribute("title");
      var title = event.target.getAttribute("value");
      (this.report = report), (this.title = title);
      return apiCall
        .report(this.reportTitle)
        .then(({ data }) => {
          this.data = data;
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
          throw error;
        });
    },
    outVal(value) {
      var split = value.split(",");
      var front9 = split.slice(0, 9);
      for (var i = 0; i < front9.length; i++) front9[i] = +front9[i];
      var sum = front9.reduce(function(a, b) {
        return a + b;
      }, 0);
      return sum;
    },
    inVal(value) {
      var split = value.split(",");
      var back9 = split.slice(9, 18);
      for (var i = 0; i < back9.length; i++) back9[i] = +back9[i];
      var sum = back9.reduce(function(a, b) {
        return a + b;
      }, 0);
      return sum;
    },
    totalVal(value) {
      var split = value.split(",");
      for (var i = 0; i < split.length; i++) split[i] = +split[i];
      var sum = split.reduce(function(a, b) {
        return a + b;
      }, 0);
      return sum;
    },
    currentStatus(value, status) {
      if (value === "X") status = "Not Entered";
      else if (value === "W") status = "Withdrawn";
      else if (value === "R") status = "Reserve";
      else if (value === "F") status = "Failed to Qualify";
      else if (value === "E") status = "Entered";
      else if (value === "L") status = "Late Entry";
      else if (value === "Q") status = "Required to Qualify";
      else if (value === "C") status = "Cut";
      return status;
    },
    onEnter: function(user, password, text, code, id, fee) {
      user = sessionStorage.getItem("playerID", "");
      password = sessionStorage.getItem("password", "");
      text = this.form.text;
      code = this.code;
      id = this.id;
      fee = this.tourinfo.entry_fee;
      socketServe.enterSocket(user, password, text, code, id, fee);
      return this.$bvModal.hide("ew");
    },
    onWithdraw: function(user, password, text, code, id, fee) {
      user = sessionStorage.getItem("playerID", "");
      password = sessionStorage.getItem("password", "");
      text = this.form.text;
      code = this.code;
      id = this.id;
      fee = this.tourinfo.entry_fee;
      socketServe.withdrawSocket(user, password, text, code, id, fee);
      return this.$bvModal.hide("ew");
    },
    onPay: function(user, password, code, id, fee) {
      user = sessionStorage.getItem("playerID", "");
      password = sessionStorage.getItem("password", "");
      code = this.code;
      id = this.id;
      fee = this.tourinfo.entry_feeowe;
      socketServe.paySocket(user, password, code, id, fee);
      return this.$bvModal.hide("ew");
    },
    async login() {
      try {
        // First call, await for call to return
        let first_call = await apiCall.tmParamsPlayer(
          this.id,
          this.loggedin.playerID,
          this.code
        );
        this.tourinfo = first_call.data;
        this.until = parseInt(first_call.data.days_away);
        this.showGender = first_call.data.show_gender;
        this.loading = false;
        // Second call, await for call to return
        let second_call = await apiCall.report(this.reportTitle);
        this.data = second_call.data;
        this.loading = false;
      } catch (error) {
        console.log("error in await calls");
        console.log(error);
        throw error;
      }
    },
    async notLogin() {
      try {
        // First call, await for call to return
        let first_call = await apiCall.tmParams(this.id, this.code);
        this.DEFIMAGESAMS3 = first_call.data.tm_params.DEFIMAGESAMS3;
        this.tourinfo = first_call.data;
        this.tourinfoDate = first_call.data.dates;
        this.tournCountdown(this.tourinfo); 
        // this.countDown();
        // this.myTimeout = clearTimeout(this.tournCountdown());
        if (Array.isArray(this.tourinfo.reports.reports_entry)) {
          let arr = [];
          let arrURL = [];
          this.tourinfo.reports.reports_entry.forEach((value) => {
              if (value.report_title.includes('Entries') || value.report_title.includes('Draw') || value.report_title.includes('Score') || value.report_title.includes('Final')) {
                  arr.push(value.report_title) 
                  arrURL.push(value.report_url) 
              }
          });
          this.lastListTitle = arr.slice(-1);
          this.ListlastTite = this.lastListTitle[0];
          this.lastListURL = arrURL.slice(-1);
          this.ListlastURL = this.lastListURL[0];
        }
        this.until = first_call.data.days_away;
        this.useName = first_call.data.use_full_name;
        this.showGender = first_call.data.show_gender;
        this.is_qualifier = first_call.data.is_qualifier;
        this.stableford = first_call.data.stableford;
        this.show_info_web = first_call.data.tm_params.show_info_web;
        console.log("this.show_info_web")
        console.log(this.show_info_web)
        this.hide_score_card = first_call.data.hide_score_card;
        console.log("this.hide_score_card")
        console.log(this.hide_score_card)
        if (first_call.data.prize_funds.fund) {
          if (Array.isArray(first_call.data.prize_funds.fund)) {
            this.FullListPrize = first_call.data.prize_funds.fund;
            console.log('In Array')
          } else {
            this.FullListPrize = [first_call.data.prize_funds.fund];
              console.log('In Not Array')
          }
        } 
        this.loading = false;
        // Second call, await for call to return
        let second_call = await apiCall.report(this.reportTitle);
        this.data = second_call.data;
        console.log("data");
        console.log(this.data);
        console.log("showGender");
        console.log(this.showGender);
      // this.countDown(); 
        // clearTimeout(this.myTimeout);
        // this.countDownTimer();
        // this.tournCountdown(this.tourinfo); 
        this.loading = false;
      } catch (error) {
        console.log("error in await calls");
        console.log(error);
        throw error;
      }
    },
    pollData() {
      this.polling = setInterval(() => {
        // console.log("Run refresh");
        this.notLogin();
        clearTimeout(this.tournCountdownTimer)
        // this.countDown(); 
      }, 30000);
    },
    reportTitleFun() {
      let repT = this.ListlastTite;
      if (Array.isArray(this.tourinfo.reports.reports_entry)) {
        this.title = repT;
        // console.log("this.title")
        // console.log(this.title)
      } else {
        this.title = 'Tournament Entries';
        // console.log("this.title")
        // console.log(this.title) 
      }
    }
  },
  computed: {
    PlayerLogged: function(player) {
      if (this.loggedin === "" || this.loggedin.status === null)
        player = "guest";
      else player = this.loggedin.playerID;
      this.login();
      return player;
    },
    teamEvent: function(team) {
      var array = this.data;
      if (array["team_scores"] !== undefined) team = "Y";
      else team = "N";
      return team;
    },
    currentReport: function(cr) {
      if (this.report === "") {
        if (Array.isArray(this.tourinfo.reports.reports_entry)) {
          cr = this.ListlastURL;
          console.log("Arrya")
        } else cr = this.tourinfo.reports.reports_entry.report_url;
        console.log("NOT Arrya")
      } else cr = this.report;
      return cr;
    },
    reportTitle: function(url) {
      if (this.currentReport.indexOf("tmentry") !== -1) {
        url =
          this.config.VUE_APP_API +
          "sst" +
          "/cache/" +
          this.apiClass +
          "/" +
          this.$route.query.id +
          "/" +
          this.$route.query.id +
          "-" +
          this.$route.query.code +
          "-entry-entries.json?randomadd=" +
          new Date().getTime();
      } else {
        if (this.currentReport.indexOf("tmscore") !== -1) {
          var subRep2 = this.currentReport.lastIndexOf("params=") + 7;
          var indNext2 = this.currentReport.indexOf("~", subRep2);
          var repParams = this.currentReport.substr(
            subRep2,
            indNext2 - subRep2
          );
          if (repParams && repParams.indexOf(".cgi") < 0) {
            url =
              this.config.VUE_APP_API +
              "sst" +
              "/cache/" +
              this.apiClass +
              "/" +
              this.$route.query.id +
              "/" +
              this.$route.query.id +
              "-" +
              this.$route.query.code +
              "-scores-" +
              repParams +
              ".json" +
              "?randomadd=" +
              new Date().getTime();
          } else {
            url =
              this.config.VUE_APP_API +
              "sst" +
              "/cache/" +
              this.apiClass +
              "/" +
              this.$route.query.id +
              "/" +
              this.$route.query.id +
              "-" +
              this.$route.query.code +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
          }
        } else if (this.currentReport.indexOf("tmlsmon") !== -1) {
          {
            url =
              this.config.VUE_APP_API +
              "sst" +
              "/cache/" +
              this.apiClass +
              "/" +
              this.$route.query.id +
              "/" +
              this.$route.query.id +
              "-" +
              this.$route.query.code +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
          }
        } else if (this.currentReport.indexOf("tmdraw") !== -1) {
          var subRep = this.currentReport.lastIndexOf("round=") + 6;
          var indNext = this.currentReport.indexOf("~", subRep);
          var drawRnd = this.currentReport.substr(subRep, indNext - subRep);
          url =
            this.config.VUE_APP_API +
            "sst" +
            "/cache/" +
            this.apiClass +
            "/" +
            this.$route.query.id +
            "/" +
            this.$route.query.id +
            "-" +
            this.$route.query.code +
            "-draw-R" +
            drawRnd +
            "-draw.json" +
            "?randomadd=" +
            new Date().getTime();
        } else if (this.currentReport.indexOf("tmresult") !== -1) {
          var subRep1 = this.currentReport.lastIndexOf("result=") + 7;
          var indNext1 = this.currentReport.indexOf("~", subRep1);
          var resNum1 = this.currentReport.substr(subRep1, indNext1 - subRep1);
          console.log("resNum === ");
          console.log(resNum1);
          url =
            this.config.VUE_APP_API +
            "sst" +
            "/cache/" +
            this.apiClass +
            "/" +
            this.$route.query.id +
            "/" +
            this.$route.query.id +
            "-" +
            this.$route.query.code +
            "-result-result-" +
            resNum1 +
            ".json" +
            "?randomadd=" +
            new Date().getTime();
        } else {
          url =
            this.config.VUE_APP_API +
            "sst" +
            "/cache/" +
            this.apiClass +
            "/" +
            this.$route.query.id +
            "/" +
            this.$route.query.id +
            "-" +
            this.$route.query.code +
            "-result-result-PF.json" +
            "?randomadd=" +
            new Date().getTime();
        }
      }
      return url;
    }
  },
  mounted() {
    console.log('mounted');
    if (this.loggedin.status === null || this.loggedin === "") {
      // clearTimeout(this.tournCountdownTimer);
      this.notLogin();
      // this.countDown(); 
      // this.clearTime = clearTimeout(this.myTimeout);
      this.ReportTitleText = setTimeout(() => {
        // console.log("Run reportTitle");
        this.hideLoader = true;
        this.reportTitleFun();
      }, 3000);
    } else {
      this.login();
    }
    // this.getTournDate();
  },
  beforeDestroy() {
    console.log('unmounted')
    clearTimeout(this.tournCountdownTimer);
  }
};
</script>
<style scoped>
.insideLoader {
  margin: auto;
  text-align: center;
  display: block;
}
.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #214232;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  margin: auto;
  margin-top: 30px;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.showPgender {
  color: #026638;
  font-weight: 600;
}
span.multiDot-size-reportgender {
  font-size: 30px !important;
  line-height: 0px !important;
  position: relative;
  top: 6px;
}
.female {
  color: #e33;
}
.male {
  color: #037;
}
::v-deep li.nav-item.nonactive > a {
  color: #f2af15 !important;
}
::v-deep .nav-tabs .nav-link {
  margin-bottom: -2px;
  border: 0px solid transparent !important;
}
::v-deep .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #ffffff !important;
  background-color: #026638;
  border-color: #026638 #026638 #026638;
}
::v-deep .mt-3,
.my-3 {
  margin-top: 0rem !important;
}
::v-deep .tabsLi > div > ul > li {
  margin-right: 20px;
}
.reportSection {
  padding: 0px !important;
}
.tourInfo.reportSection.container.tournReportSection {
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.heightColorDiv {
  background: #006737;
  height: 30px;
  display: none;
}
.tourInfo {
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  margin-top: 2em;
  color: #6c6c6c;
  font-size: 13px;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
h3.courseDates {
  color: #026034;
  font-weight: bold;
  font-size: 14px;
  text-align: left !important;
}
.TitleArea {
  margin-bottom: 0px;
  margin-top: 5px;
  display: none;
}
.TitleAreaScore {
  margin-bottom: 25px;
  margin-top: 40px;
}
.lastRealTime-update {
  margin-top: 30px;
  margin-bottom: 2em;
}
@media only screen and (max-width: 500px) {
  ::v-deep .tabsLi > div > ul > li {
    margin-right: 0px;
    display: contents !important;
  }
  ::v-deep li.nav-item.nonactive.HBH {
    display: none !important;
  }
}
</style>
